<template>
  <div class="creams-new">
    <creams-form @submit="onSubmit" :alert="alert"></creams-form>
  </div>
</template>

<script>
import flash from '../../../services/flash'
import creamsForm from './_form'

export default {
  components: { creamsForm },

  data () {
    return {
      alert: {}
    }
  },

  methods: {
    onSubmit ({cream, form}) {
      this.$http.post('/api/creams', form)
        .then(() => {
          flash.set({
            type: 'success',
            message: `Sorte ${cream.name} hinzugefügt`
          })
          this.$router.push('/creams')
        })
        .catch((reason) => {
          if (!reason.body.errors) return console.log(reason)
          this.alert = flash.now({
            type: 'danger',
            code: reason.body.errors[0],
            data: {
              name: cream.name
            }
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// new.vue?dd092842